import React, { useMemo } from "react";

import { Box, Divider, Switch, Typography } from "@mui/material";

import { useShareContext } from "../context/share-context";
import { AccessThree } from "./AccessThree";

export const AccessForm: React.FC = () => {
  const { stepKey, state, setFullAccess, dealId } = useShareContext();
  if (!dealId) return null;

  const renderParentFolders = useMemo(() => {
    return (
      <Box display="flex" flexDirection="column" maxHeight={300} overflow="auto" pl="10px">
        {state[stepKey]?.components.map((component) => {
          return <AccessThree key={component.id} component={component} subIndex={1} />;
        })}
      </Box>
    );
  }, [state, stepKey]);

  return (
    <Box display="flex" flexDirection="column" width="100%" gap="13px" minWidth="260px">
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography sx={{ fontSize: "16px", color: "#0a3142", fontWeight: 500 }}>Full Access</Typography>
        <Switch
          focusVisibleClassName=".Mui-focusVisible"
          disableRipple
          checked={state[stepKey]?.deal_id?.includes(dealId)}
          onChange={() => setFullAccess(stepKey)}
          sx={{
            width: 48,
            height: 24,
            padding: 0,
            "& .MuiSwitch-switchBase": {
              padding: 0,
              margin: "2px",
              transitionDuration: "300ms",
              color: "#bac7ce",
              "&.Mui-checked": {
                transform: "translateX(23px)",
                color: "#0a3142",
                "& + .MuiSwitch-track": {
                  backgroundColor: "#dae0e2",
                  opacity: 1,
                  border: 0
                },
                "&.Mui-disabled + .MuiSwitch-track": {
                  opacity: 0.5
                }
              },
              "&.Mui-focusVisible .MuiSwitch-thumb": {
                color: "#33cf4d",
                border: "6px solid #fff"
              },
              "&.Mui-disabled .MuiSwitch-thumb": {
                opacity: 0.7
              },
              "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.3
              }
            },
            "& .MuiSwitch-thumb": {
              boxSizing: "border-box",
              width: 20,
              height: 20
            },
            "& .MuiSwitch-track": {
              borderRadius: "34px",
              backgroundColor: "#dae0e2",
              opacity: 1,
              transition: "background-color 500ms"
            }
          }}
        />
      </Box>
      <Divider
        orientation="horizontal"
        flexItem
        sx={{
          height: "1px",
          width: "100%",
          backgroundColor: "transparent",
          borderBottomWidth: "1px",
          borderColor: "#dae0e2"
        }}
      />
      {renderParentFolders}
    </Box>
  );
};
